
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
// @ts-ignore
import TrackeData from '@/utils/trackData';
import { Modal, Button } from 'ant-design-vue';
import { namespace } from 'vuex-class';
import BeikeBtn from '@/components-business/beike-btn.vue';
import ShoukeBtn from '@/components-business/shouke-btn.vue';
import BanshuBtn from '@/components-business/banshu-btn.vue';
import utils from '@/utils/index';
import BanshuDialog from './banshu-dialog.vue';

const userModule = namespace('user');
const lessonDialogModule = namespace('lessonDialog');
let timer: any = null;
// ai小班: 6:ai小班 17ai短线小班
const aiSmallClass: number[] = [6, 17];
@Component({
  components: {
    aModal: Modal,
    aButton: Button,
    BeikeBtn,
    ShoukeBtn,
    BanshuBtn,
    BanshuDialog,
  },
  filters: {
    wordsLen(text: string) {
      return utils.sub(text, 48);
    },
  },
})
export default class LessonDialog extends Vue {
[x: string]: any;

  // 获取用户信息
  @userModule.Getter('userInfo') userInfo: any

  // 是否为助教
  @userModule.Getter('isDt') isDTAssistant: any

  @userModule.Getter('getRemoteLoginCount') remoteLoginCount!: number

  // 是否是北校机构
  @userModule.Getter('isGaosi') isGaosi!: boolean

  // 获取当前班级信息
  @lessonDialogModule.Getter('getCurrentClass') currentClass: any

  // 获取讲次列表
  @lessonDialogModule.Getter('getLessonList') lessonList: any

  // 弹窗显示状态
  @lessonDialogModule.Getter('getVisible') visible!: boolean

  @lessonDialogModule.Mutation('updateVisible') updateVisible: any

  private href: string = encodeURIComponent(window.location.href)

  private domain: string = process.env.VUE_APP_JUMPURL;

  private currentTime: number = 0;

  // 板书弹框显示状态
  private banshuModalVisible: boolean = false;

  // 板书弹框 需要的讲次数据
  private banshuLesson: { lessonId: number; lessonName: string; classId: number; lessonNum: number } = {
    lessonId: 0, lessonName: '', classId: 0, lessonNum: 0,
  };

  // 名称
  get title(): string {
    return this.currentClass.name;
  }

  // 学情分析
  get studyAnalyse(): boolean {
    return this.currentClass.type === 1
          && this.currentClass.classType !== 0
          && this.isDTAssistant;
  }

  // 添加学员
  get addStudent(): boolean {
    return this.currentClass.addStudent;
  }

  // 快速建班
  get createClass(): boolean {
    return this.currentClass.type === 2
          && this.currentClass.createClass
          && this.currentClass.fastCreateClass === 1;
  }

  // 错题本(courseConfigVersion:0 五件套,1:三阶课)
  get wrongRecord(): boolean {
    return this.currentClass.type === 1
           && this.currentClass.courseConfigVersion === 1;
  }

  // ai小班
  get isAISmallClass(): boolean {
    return aiSmallClass.indexOf(this.currentClass.classType) !== -1;
  }

  // 是否显示数据按钮
  showDataBtn(lessonItem: any): boolean {
    return this.currentClass.type === 1 && lessonItem.hasMsPenScreenshot !== null;
  }

  @Watch('visible')
  handleLessonDialogChange(newVal: boolean) {
    if (newVal) {
      this.currentTime = Date.now();
      this.$nextTick(() => {
        const maxHeight: number = document.body.clientHeight;
        const modalContent: any = document.getElementsByClassName('ant-modal-content');
        const modalContentHeight: number = modalContent[0].clientHeight;
        if (modalContentHeight > maxHeight) {
          modalContent[0].style.top = '120px';
        } else {
          modalContent[0].style.top = '0px';
        }
      });
      // 延迟检查 this.$track 是否有值 埋点
      const checkTrack = setInterval(() => {
        if (this.currentClass.name) {
          const { id, classId, name } = this.currentClass;
          this.$track.sendPageLog(TrackeData.PRELESSONSDETAIL_PAGE_SHOW, { id: id || classId, name });
          clearInterval(checkTrack);
        }
      }, 100); // 每100毫秒检查一次
    } else {
      this.currentTime = 0;
    }
  }

  // 点击埋点
  private clickTrack(action: string, params: any) {
    this.$track.sendClickLog(TrackeData[action], params);
  }

  // 快速建班处理
  private handleCreateClass() {
    this.$utils.sendAction('index', 'index', 'id-8'); // 建班埋点
    timer = setTimeout(() => {
      window.location.href = `${this.domain}/createClass.html#/?classTypeId=${this.currentClass.classTypeId}&newDiyFlag=${this.currentClass.newDiyFlag}&lessonId=${this.lessonList[0].lessonId}&num=1&name=${this.currentClass.name}&courseConfigVersion=${this.currentClass.courseConfigVersion}&refer=fastCreateClass&referUrl=${this.href}`;
    }, 100);
    this.clickTrack('PRELESSONS_BUILDCLASS_CLICK', { id: this.currentClass.classTypeId, name: this.currentClass.name });
  }

  // 关闭弹窗
  private handleCancel() {
    this.updateVisible(false);
  }

  // 更新当前时间(埋点需求)
  private updateCurrentTime() {
    // 打开弹窗后第一次点击备课/授课后置0
    this.currentTime = 0;
  }

  // 跳转到数据页面
  private goToData(lessonItem: any) {
    if (lessonItem && lessonItem.lessonId && lessonItem.msReviewFlag) {
      const prefix = process.env.NODE_ENV === 'development' ? '' : '/next';
      const href = `${prefix}/dataInfo.html#/index?classId=${this.currentClass.classId}&lessonId=${lessonItem.lessonId}&className=${this.currentClass.name}&lessonNum=${lessonItem.lessonNum}`;
      window.open(href, '_blank');
    }
  }

  /**
   * @desc 打开板书截图弹框
   */
  private async openBanshuModal(data: { lessonId: number; lessonName: string; classId: number; lessonNum: number }) {
    this.banshuLesson = data;
    this.banshuModalVisible = true;
  }

  private handleBanshuModalVisibleChange(visible: boolean) {
    this.banshuModalVisible = visible;
  }

  private handleBanshuClickTrack(data: { action: string; params: any }) {
    // 仅当 trackData 中已配置该 action 时发埋点，避免 ali-tracking 报 "Failed to get the configuration file!"
    if (data && data.action && data.params && TrackeData[data.action]) {
      this.clickTrack(data.action, data.params);
    }
  }

  private destroyed() {
    clearTimeout(timer);
  }
}
